module.exports = __webpack_public_path__ + "img/bg07.fc28ab37.gif";